var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2716 10.5291C23.0978 10.2879 22.8693 10.0915 22.6047 9.95605C22.3402 9.82059 22.0472 9.74997 21.75 9.75H20.625V8.25C20.625 7.75272 20.4275 7.27581 20.0758 6.92417C19.7242 6.57254 19.2473 6.375 18.75 6.375H12.375L9.87563 4.5C9.55069 4.25731 9.15619 4.12581 8.75063 4.125H3.75C3.25272 4.125 2.77581 4.32254 2.42417 4.67417C2.07254 5.02581 1.875 5.50272 1.875 6V19.5C1.875 19.7984 1.99353 20.0845 2.2045 20.2955C2.41548 20.5065 2.70163 20.625 3 20.625H19.7906C20.0235 20.6253 20.2508 20.5533 20.441 20.419C20.6313 20.2847 20.7752 20.0946 20.8528 19.875L23.5238 12.2372L23.5294 12.2213C23.6238 11.939 23.6497 11.6383 23.6048 11.344C23.56 11.0498 23.4458 10.7704 23.2716 10.5291ZM8.625 6.375L11.325 8.4C11.5197 8.54605 11.7566 8.625 12 8.625H18.375V9.75H6.54094C6.14905 9.75003 5.76701 9.87285 5.44853 10.1012C5.13004 10.3296 4.89111 10.652 4.76531 11.0231L4.125 12.8578V6.375H8.625ZM18.9928 18.375H4.58344L6.80719 12H21.2222L18.9928 18.375Z",
    fill: "#1E1147",
    fillOpacity: 0.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTickets);
export default __webpack_public_path__ + "static/media/open-tickets.57f99b9a05208d8acccdc0fec7953bdc.svg";
export { ForwardRef as ReactComponent };